function initWelcome() {
  const welcomeLinks = document.querySelector('.welcome__links .swiper');

  if (!welcomeLinks) return;

  const welcomeLinksSwiper = new Swiper(welcomeLinks, {
    slidesPerView: 'auto',
    spaceBetween: 15,
    navigation: {
      nextEl: '.welcome__links .swiper-next-button',
      prevEl: '.welcome__links .swiper-prev-button',
    },
  });

  const welcomeCatalogSearch = document.querySelector('.welcome__catalog-search');
  const header = document.querySelector('.header');
  const welcomeCatalogLink = document.querySelector('.welcome__catalog-link');
  const welcomeWrapper = document.querySelector('.welcome__wrapper');
  const headerOverlay = document.querySelector('.header__overlay');
  const welcomeCatalogSearchClear = document.querySelector('.welcome__catalog-search-clear');

  if (!welcomeCatalogSearch) return;

  // Функция для пересчета размеров и позиции поискового поля
  function updateCatalogSearchPosition() {
    welcomeCatalogSearch.style.left = welcomeCatalogLink.clientWidth + 'px';
    welcomeCatalogSearch.style.width = welcomeWrapper.clientWidth - welcomeCatalogLink.clientWidth + 1 + 'px';
  }

  // Функция для сброса размеров поискового поля к дефолтным
  function resetCatalogSearchPosition() {
    welcomeCatalogSearch.style.left = '0';
    welcomeCatalogSearch.style.width = '100%';
  }

  welcomeCatalogSearch.addEventListener('click', () => {
    header.classList.add('header--search');
    updateCatalogSearchPosition();
  });

  headerOverlay.addEventListener('click', () => {
    header.classList.remove('header--search');
    resetCatalogSearchPosition();

    header.classList.remove('header--catalog');
  });

  window.addEventListener('resize', () => {
    if (header.classList.contains('header--search')) {
      updateCatalogSearchPosition();
    }
  });

  welcomeCatalogSearchClear.addEventListener('click', () => {
    header.classList.remove('header--search');
    resetCatalogSearchPosition();
  });

  welcomeCatalogLink.addEventListener('click', () => {
    header.classList.toggle('header--catalog');
  });
}

export { initWelcome };